<template>
  <div id="app" class="app-root">
    <div v-if="authChecking" class="app-loading" role="status" aria-live="polite">
      <img src="/images/branding/stratitude-logo-icon.png" alt="" class="app-loading__icon">
      <div>
        <strong>Opening Stratitude Share</strong>
        <span>Checking your secure session…</span>
      </div>
    </div>

    <LoginScreen
      v-else-if="!isAuthenticated"
      @authenticated="handleAuthenticated"
    />

    <div v-else class="workspace-shell">
      <AppHeader
        :active-view="activeView"
        :user-email="auth.email"
        :logout-loading="logoutLoading"
        @navigate="navigate"
        @logout="logout"
      />

      <router-view
        :auth="auth"
        @navigate="navigate"
        @session-missing="clearSession"
      />
    </div>
  </div>
</template>

<script>
import AppHeader from './components/AppHeader.vue'
import LoginScreen from './views/LoginScreen.vue'
import { logoutSession } from './services/shareApi'
import { clearAuth, readAuth } from './utils/auth'

export default {
  name: 'StratitudeShare',

  components: {
    AppHeader: AppHeader,
    LoginScreen: LoginScreen
  },

  data: function () {
    return {
      authChecking: true,
      auth: null,
      logoutLoading: false
    }
  },

  computed: {
    isAuthenticated: function () {
      return Boolean(this.auth && this.auth.token && this.auth.email)
    },

    activeView: function () {
      return this.$route && this.$route.name === 'our-shares' ? 'activity' : 'upload'
    }
  },

  mounted: function () {
    this.auth = readAuth()
    this.authChecking = false
  },

  methods: {
    navigate: function (target) {
      var path = typeof target === 'string' ? target : target.path
      var query = typeof target === 'object' && target.query ? target.query : null
      var location = query ? { path: path, query: query } : { path: path }
      var resolved = this.$router.resolve(location).route

      if (this.$route.fullPath !== resolved.fullPath) {
        this.$router.push(location).catch(function (error) {
          if (!error || error.name !== 'NavigationDuplicated') {
            throw error
          }
        })
      }

      window.scrollTo({ top: 0, behavior: 'auto' })
    },

    handleAuthenticated: function (auth) {
      this.auth = auth
      this.navigate('/')
    },

    clearSession: function () {
      clearAuth()
      this.auth = null
      this.navigate('/')
    },

    logout: async function () {
      if (this.logoutLoading) {
        return
      }

      this.logoutLoading = true

      try {
        if (this.auth && this.auth.token) {
          await logoutSession(this.auth.token)
        }
      } catch (error) {
        // A failed remote logout must not prevent the local session being cleared.
      } finally {
        this.logoutLoading = false
        this.clearSession()
      }
    }
  }
}
</script>
